import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    greeting: {
      marginBottom: theme.spacing(3),
    },
    title: {
      paddingBottom: theme.spacing(2),
    },
    valuationGreetings: {
      padding: theme.spacing(3, 5),
      marginBottom: theme.spacing(3),
      background: theme.palette.background.paper,
    },
    instructionText: {
      marginBottom: theme.spacing(3),
    },
    instructionList: {
      paddingInlineStart: '1rem',
    },
  })
);
